/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RenderTableFilterInput = {
    id?: (string | null);
    /**
     * Use expression for LX boolean filters, or cashflow_tag for cashflow tag filters.
     */
    filter_type?: RenderTableFilterInput.filter_type;
    /**
     * LX boolean expression. Required when filter_type=expression.
     */
    expression?: (string | null);
    /**
     * Namespace id/name. Defaults to request namespace.
     */
    namespace?: (string | null);
    /**
     * Cashflow tag category id.
     */
    tag_category_id?: (string | null);
    /**
     * Cashflow tag values to include.
     */
    tag_filter_values?: (Array<string> | null);
    /**
     * Cashflow tag matching operator. Defaults to any.
     */
    tag_filter_operator?: ('all' | 'any' | null);
    /**
     * Deprecated compatibility flag. Cashflow routing is detected from property metadata.
     */
    is_cashflow?: boolean;
};

export namespace RenderTableFilterInput {

    /**
     * Use expression for LX boolean filters, or cashflow_tag for cashflow tag filters.
     */
    export enum filter_type {
        EXPRESSION = 'expression',
        CASHFLOW_TAG = 'cashflow_tag',
    }


}

